import { Injectable } from "@angular/core";
import { ApiService } from "app/core/http/api.service";
import { buildHttpOptions } from "app/core/http/BuildHttpOptions";
import { Observable } from "rxjs";

export class SalesDashboardSummaryResponse {
    reservedVehicles: SalesDashboardSummaryVehicleDto[];
    contractsInProgress: SalesDashboardSummaryContractDto[];
    soldCarsThisWeek: SalesDashboardSummarySoldCarDto[];
    pendingDeliveries: number;
    userPendingDeliveries: number;
    totalContracts: SalesAdminDashboardContractsDto[];
    schedules: SalesAdminDayScheduleDto[];
}
export interface SalesDashboardSummaryVehicleDto {
    expiringSoon: boolean;
}

export interface SalesDashboardSummaryContractDto {
    awaitingDocs: boolean;
}

export interface SalesDashboardSummarySoldCarDto {
    delivered: boolean;
}

export interface SalesAdminDayScheduleDto {
    description: string;
    date: string;
    time: string;
    type: string;
    deliveryType:string;
}

export interface SalesAdminDashboardContractsDto {
    date: string;
    status: LegacyContractStatusEnum;
}

export enum LegacyContractStatusEnum {
    Unknown = 0,
    Canceled = 1,
    InProcess = 2,
    Completed = 3,
    Accounted = 4
}

@Injectable({ providedIn: 'root' })
export class SalesDashboardService {

    dashboardUrl = '/dashboard/sales/';
    constructor(private api: ApiService) { }

    getSalesDashboardData(scheduleDay: string, soldCarsTimePeriod: string): Observable<SalesDashboardSummaryResponse> {

        const options = buildHttpOptions({
            extraParams: { scheduleDay: scheduleDay, soldCarsTimePeriod: soldCarsTimePeriod }
        });

        return this.api.get<SalesDashboardSummaryResponse>(this.dashboardUrl + 'summary', options);
    }
}